import React from "react"

export class ShowImagePlaceholder extends React.Component {
  render () {
    const outerStyle = {
      width: '100%',
      maxWidth: 250,
      maxHeight: 312,
      height: 312, 
      backgroundColor: '#2c2c2cff',
      borderRadius: 0,
      marginBottom: 12,
      boxSizing: 'border-box',
      padding: '12px 16px'
    };

    const innerStyle = {
      width: '100%',
      height: '100%',
      backgroundColor: '#555',
      padding: '16px',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column', 
    };

    const largeRectangleStyle = {
      backgroundColor: '#444', 
      height: '80px',
      borderRadius: '2px', 
    };
    
    const rowContainerStyle = {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '8px', 
      marginBottom: '5px',
    };

    const smallRectangleBase = {
      backgroundColor: '#444', 
      height: '40px', 
      borderRadius: '2px', 
    };

    return (
      <div style={outerStyle}>
        <div style={innerStyle}>          
          <div style={rowContainerStyle}>
            <div style={{ ...smallRectangleBase, width: '30%' }}></div>
            <div style={{ ...smallRectangleBase, width: '40%' }}></div>
          </div>
          
          <div style={rowContainerStyle}>
            <div style={{ ...smallRectangleBase, width: '40%' }}></div>
            <div style={{ ...smallRectangleBase, width: '50%' }}></div>
          </div>
          
          <div style={rowContainerStyle}>
            <div style={{ ...smallRectangleBase, width: '60%' }}></div>
          </div>
          <br /><br />
          
          <div style={largeRectangleStyle}></div> 

        </div>
      </div>
    );
  }
}